import { INTERNAL_ROW_KEY } from '../../config/table'

import { filterData } from '../modules/filter'
import { sortData } from '../modules/sortable'
import { expandedData } from '../modules/expand'
import { mergeCellsData } from './merge-cell'
import { checkboxData } from '../modules/checkbox'
import { getValue } from '../../utils/tools'
// 生成uuid
const ustr = () =>
  Math.random()
    .toString(36)
    .substr(3)
export const createUuid = () => ustr() + ustr()

export function createTableRenderData(coreInstance) {
  const { tableData, depthMap, checkboxData } = formatTableDataQueue(coreInstance)
  return {
    data: coreInstance.data,
    depthMap,
    _tableData: tableData,
    _checkboxData: checkboxData,
    tableDataLength: tableData.length,
  }
}

function formatTableDataQueue(coreInstance) {
  const { table } = coreInstance
  const taskQueue = [
    // 初始化相关的配置。比如无rowKey时、a.b这种平铺字段、index索引邓
    (formatDataResult) => integrateData(formatDataResult, coreInstance),
    // 内置过滤器格式化tableData
    (formatDataResult) => filterData(formatDataResult, coreInstance),
    // 内置排序格式化tableData
    (formatDataResult) => sortData(formatDataResult, coreInstance),
    // 获取合并行列配置
    (formatDataResult) => mergeCellsData(formatDataResult, coreInstance),
    // 树形表格数据扁平化处理
    (formatDataResult) => expandedData(formatDataResult, coreInstance),
    // 生成checkbox专属的数据
    (formatDataResult) => checkboxData(formatDataResult, coreInstance),
  ]
  // 此处兼容树形表格合并更新，场景：树形展开扁平化后数据变化无法重新计算需要合并的行列
  if (table.$props.expandColumnKey) {
    taskQueue.push(
      ...[
        (formatDataResult) => integrateData(formatDataResult, coreInstance),
        (formatDataResult) => mergeCellsData(formatDataResult, coreInstance)
      ]
    )
  }
  const formatDataResult = {
    tableData: coreInstance.data || [],
  }
  const result = taskQueue.reduce(
    (result, taskCallback) => taskCallback(result),
    formatDataResult
  )

  return result
}

// 生成_index 给query-table的详情分页器使用 search-pager
function createDefaultRowIndexIter(result, index) {
  result['_index'] = index + 1
}

function createDefaultId(result, index) {
  result[INTERNAL_ROW_KEY] = createUuid()
}

export function formatTableFlatData(renderData, coreInstance) {
  const mainColumns = coreInstance.states.mainColumns
  renderData.forEach(rowData => {
    flatData(rowData, mainColumns, coreInstance)
  })
}

export function flatData(result, visibleFlatColumns, vm) {
  for (let i = 0; i < visibleFlatColumns.length; i++) {
    const { key } = visibleFlatColumns[i] || {}
    // if (!key || result.hasOwnProperty(key)) {
    // 2024-12-16 解密的场景会有问题。此时自动解密之后，不会在走进这里了
    if (!key) {
      continue
    }
    const maskKey = key + 'Mask'
    const virtualKey = key + 'Virtual'
    let maskVal = getValue(maskKey, result)
    let virtualVal = getValue(virtualKey, result)
    if (maskVal) {
      vm.$set(result, maskKey, maskVal)
    }
    if (virtualVal) {
      vm.$set(result, virtualKey, virtualVal)
    }
    const val = getValue(key, result)
    if ((maskVal || virtualVal) || val !== undefined) {
      vm.$set(result, key, getValue(key, result))
    }
  }
}

export function integrateData(formatDataResult, coreInstance) {
  const data = formatDataResult.tableData || []
  const rowKey = coreInstance.table.$props.rowKey
  const visibleFlatColumns = coreInstance.store.states.visibleFlatColumns

  const taskQueue = [
    (result, index) => flatData(result, visibleFlatColumns, coreInstance.store, index),
    (result, index) => createDefaultRowIndexIter(result, index),
  ]
  if (rowKey === INTERNAL_ROW_KEY) {
    taskQueue.push((result, index) => createDefaultId(result, index))
  }
  data.forEach((cur, index) => {
    taskQueue.forEach((taskCallback) => taskCallback(cur, index))
  })
  return formatDataResult
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/config/data.js